import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { RetirementCalculatorPage } from '../retirement-tools/retirement-calculator/retirement-calculator';
import { ExpenseCalculatorPage } from '../retirement-tools/expense-calculator/expense-calculator';

@IonicPage()
@Component({
  selector: 'page-tools',
  templateUrl: 'tools.html',
})
export class ToolsPage {

  public pages: any[] = [
    { title: "Análisis de gastos actuales y a la jubilación", icon: "cash", component: ExpenseCalculatorPage },
    { title: "Calculadora de balance financiero a la jubilación", icon: "calculator", component: RetirementCalculatorPage }

  ];

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController) {
  }

  ionViewDidLoad() { }

  public closeModal(): void {
    this.viewCtrl.dismiss();
  }

  public openPage(page): void {
    this.navCtrl.push(page);
  }

}



// WEBPACK FOOTER //
// ./src/pages/tools/tools.ts